import React from "react";
import Image from "next/image";
import MobileMenus from "@/layouts/headers/menu/mobile-menus";

import bg_shape from "@/assets/img/offcanvas/bg-shape-3.png";

import { Icon } from "@/svg/Icon";

const Offcanvas2 = ({ showCanvas, setShowCanvas }: any) => {
  return (
    <>
      <div
        className={`tp-offcanvas-area-2 tp-menu-2 ${
          showCanvas ? "opened" : ""
        }`}
      >
        <div className="tp-offcanvas-shape">
          <Image className="tp-offcanvas-shape-2" src={bg_shape} alt="image" />
        </div>
        <div className="tp-offcanvas-circle-1">
          <span></span>
        </div>
        <div className="tp-offcanvas-circle-2">
          <span></span>
        </div>
        <div className="tp-offcanvas-wrapper">
          <div className="tp-offcanvas-top-2 d-flex align-items-center justify-content-between">
            <div className="tp-offcanvas-logo-2">
              <a href="#" onClick={() => setShowCanvas(false)}>
                <Icon name="LogoMuseHorizontal" width="115px" />
              </a>
            </div>
            <div className="tp-offcanvas-close-2">
              <button
                className="tp-offcanvas-close-btn-2 tp-offcanvas-open-btn-2"
                onClick={() => setShowCanvas(false)}
              >
                <Icon name="Offcanvas2" />
              </button>
            </div>
          </div>
          <div className="tp-offcanvas-main-2">
            <div className="tp-main-menu-mobile d-xl-none">
              <nav>
                <MobileMenus setShowCanvas={setShowCanvas} />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Offcanvas2;
